import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import styled from 'styled-components'
import { Layout } from '../components'

const Company = () => {
    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign:'center'}}>会社概要</h1>
            <div className='spacer-50' />
            <Container>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{width: '180px'}}>会社名</TableCell>
                            <TableCell>ニューネックス株式会社<br/>英文名称　Newnex Co., Ltd.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>設立</TableCell>
                            <TableCell>2018年10月1日</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>代表取締役</TableCell>
                            <TableCell>藤光謙司</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>取締役</TableCell>
                            <TableCell>三木智弘、加藤翼</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>所在地</TableCell>
                            <TableCell>〒153-0042 東京都目黒区青葉台1-27-3 2F</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>TEL</TableCell>
                            <TableCell>03-5544-9770</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>MAIL</TableCell>
                            <TableCell>member@newnex.net</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>WEB</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>事業内容</TableCell>
                            <TableCell>プロデュース 商品企画販売 サロン運営など</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>取扱ブランド</TableCell>
                            <TableCell>RZEUS</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>主要取引先</TableCell>
                            <TableCell>株式会社　丸井グループ 等</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Container>
            <div className='spacer-100' />
        </Layout>
    )
}
export default Company

const Container = styled(TableContainer)`
    width: 640px !important;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100% !important;
        padding: 0 20px;
    }
`